import { RouterModule, Routes } from "@angular/router";
import { QuestaoAppComponent } from "./questao.app.component";
import { PesquisaComponent } from "./pesquisa/pesquisa.component";
import { AppGuard } from "../app.authguard";
import { NgModule } from "@angular/core";
import { EditarComponent } from "./editar/editar.component";

const questaoRouterConfig:Routes=[
    {
        path:'',component:QuestaoAppComponent,
        children:[
            {
                path: 'pesquisa',
                component: PesquisaComponent,
                canActivate: [AppGuard],
                canLoad: [AppGuard],
            },
            {
                path: 'editar/:id',
                component: EditarComponent,
                canActivate: [AppGuard],
                canLoad: [AppGuard],
            },
        ]
    }
];
@NgModule({
    imports:[RouterModule.forChild(questaoRouterConfig)],
    exports:[RouterModule]
})
export class QuestaoRoutingModule{}
